export const TERMS_AND_CONDITIONS_FILE_LINK = import.meta.env.REACT_APP_IMAGES_BASE_URL + '/byzzer-terms-and-conditions/Byzzer-T%26Cs-2024.pdf';